<template>
    <section class="section section-components pb-0" id="section-components">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-12">
                     <b-card class="my-card-style">
                         <b-row>
                        <b-col sm="12" md="6">
                            <label for=""> <h4 class="mb-1"> {{ $t('oblast') }} </h4> </label>
                            <!-- <b-form-select class="mb-2" value-field="id" @input="ChangeOblast" :text-field="getLang == 'ru' ? 'fullname_ru' : getLang == 'uz_latn' ? 'fullname_latn' : 'fullname_cyrl'" v-model="filter.oblast" :options="OblastList">
                                <template #first>
                                    <b-form-select-option :value="null" disabled>-- {{$t('ChooseBelow')}} --</b-form-select-option>
                                </template>
                            </b-form-select> -->
                            <v-select
                                :options="OblastList"
                                :reduce="item => item.id"
                                v-model="filter.oblast"
                                size="xl"
                                :label="getLang == 'ru' ? 'fullname_ru' : getLang == 'uz_latn' ? 'fullname_latn' : 'fullname_cyrl'"
                                @input="ChangeOblast"
                                :placeholder="$t('ChooseBelow')"
                            >
                            </v-select>
                        </b-col>
                        <b-col sm="12" md="6">
                            <label for=""> <h4 class="mb-1"> {{ $t('region') }} </h4> </label>
                            <!-- <b-form-select class="mb-2" @input="ChangeRegion" value-field="id" :text-field="getLang == 'ru' ? 'fullname_ru' : getLang == 'uz_latn' ? 'fullname_latn' : 'fullname_cyrl'" v-model="filter.region" :options="RegionList">
                                <template #first>
                                    <b-form-select-option :value="null" disabled>-- {{$t('ChooseBelow')}} --</b-form-select-option>
                                </template>
                            </b-form-select> -->
                            <v-select
                                :disabled="filter.oblast === null"
                                :options="RegionList"
                                :reduce="item => item.id"
                                v-model="filter.region"
                                size="xl"
                                :label="getLang == 'ru' ? 'fullname_ru' : getLang == 'uz_latn' ? 'fullname_latn' : 'fullname_cyrl'"
                                @input="ChangeRegion"
                                :placeholder="$t('ChooseBelow')"
                            >
                            </v-select>
                        </b-col>
                    </b-row>
                    <b-row class="mt-3">
                        
                        <b-col sm="12" md="6">
                            <label for=""> <h4 class="mb-1"> {{ $t('bandlik_turi') }} </h4> </label>
                            <!-- <b-form-select class="mb-2" @input="ChangeSubject" value-field="id" :text-field="getLang == 'ru' ? 'fullname_ru' : getLang == 'uz_latn' ? 'fullname_latn' : 'fullname_cyrl'" v-model="filter.subject" :options="SubjectLists">
                                <template #first>
                                    <b-form-select-option :value="null" disabled>-- {{$t('ChooseBelow')}}--</b-form-select-option>
                                </template>
                            </b-form-select> -->
                            <v-select
                                :options="BandlikTuriList"
                                :reduce="item => item.id"
                                v-model="filter.bandlikturiid"
                                size="xl"
                                :label="getLang == 'ru' ? 'fullname_ru' : getLang == 'uz_latn' ? 'fullname_latn' : 'fullname_cyrl'"
                                @input="ChangeBandlikTuri"
                                :placeholder="$t('ChooseBelow')"
                            >
                            </v-select>
                        </b-col>
                        <b-col sm="12" md="6">
                            <label for=""> <h4 class="mb-1"> {{ $t('teacher') }} </h4> </label>
                            <!-- <b-form-select class="mb-2" value-field="id" @input="ChangeTeacher" :text-field="getLang == 'ru' ? 'name_ru' : getLang == 'uz_latn' ? 'name_latn' : 'name_cyrl'" v-model="filter.teacher" :options="TeacherList">
                                <template #first>
                                    <b-form-select-option :value="null" disabled>-- {{$t('ChooseBelow')}} --</b-form-select-option>
                                </template>
                            </b-form-select> -->
                            <v-select
                                :options="TeacherList"
                                :reduce="item => item.id"
                                v-model="filter.teacher"
                                size="xl"
                                :label="getLang == 'ru' ? 'name_ru' : getLang == 'uz_latn' ? 'name_latn' : 'name_cyrl'"
                                @input="ChangeTeacher"
                                :placeholder="$t('ChooseBelow')"
                            >

                            </v-select>
                        </b-col>
                    </b-row>
                    <b-row class="mt-4">
                        <b-col sm="12" md="6">
                            <label for=""> <h4 class="mb-1"> {{ $t('subject') }} </h4> </label>
                            <!-- <b-form-select class="mb-2" @input="ChangeSubject" value-field="id" :text-field="getLang == 'ru' ? 'fullname_ru' : getLang == 'uz_latn' ? 'fullname_latn' : 'fullname_cyrl'" v-model="filter.subject" :options="SubjectLists">
                                <template #first>
                                    <b-form-select-option :value="null" disabled>-- {{$t('ChooseBelow')}}--</b-form-select-option>
                                </template>
                            </b-form-select> -->
                            <v-select
                                :options="SubjectLists"
                                :reduce="item => item.id"
                                v-model="filter.subject"
                                size="xl"
                                :label="getLang == 'ru' ? 'name_ru' : getLang == 'uz_latn' ? 'name_latn' : 'name'"
                                @input="ChangeSubject"
                                :placeholder="$t('ChooseBelow')"
                            >

                            </v-select>
                        </b-col>
                        <b-col sm="12" md="6">
                            <label for=""> <h4 class="mb-1"> {{ $t('qualificationcategory') }} </h4> </label>
                            <!-- <b-form-select class="mb-2" value-field="id" :text-field="getLang == 'ru' ? 'fullname_ru' : getLang == 'uz_latn' ? 'fullname_latn' : 'fullname_cyrl'" @input="ChangeQualificationCategory" v-model="filter.qualificationcategory" :options="QualificationCategoryList">
                                <template #first>
                                    <b-form-select-option :value="null" disabled>-- {{$t('ChooseBelow')}} --</b-form-select-option>
                                </template>
                            </b-form-select> -->
                            <v-select
                                :options="QualificationCategoryList"
                                :reduce="item => item.id"
                                v-model="filter.qualificationcategory"
                                size="xl"
                                :label="getLang == 'ru' ? 'fullname_ru' : getLang == 'uz_latn' ? 'fullname_latn' : 'fullname_cyrl'"
                                @input="ChangeQualificationCategory"
                                :placeholder="$t('ChooseBelow')"
                            >

                            </v-select>
                        </b-col>
                        <b-col sm="12" md="6">
                            <!-- <label for=""> <h4 class="mb-1"> {{ $t('graduateuniversity') }} </h4> </label>
                            <b-form-select @input="ChangeUnivercity" class="mb-2" value-field="id" text-field="fullname" v-model="filter.univercity" :options="UnivercityList">
                                <template #first>
                                    <b-form-select-option :value="null" disabled>-- {{$t('ChooseBelow')}} --</b-form-select-option>
                                </template>
                            </b-form-select> -->
                        </b-col>
                    </b-row>
                    </b-card>
                    <b-card class="my-card-style mt-5">
                        <b-row  class="mt-3">
                            <b-col>
                                <b-row>
                                    <b-col sm="6" class="d-flex align-items-center justify-content-center text-center">
                                        {{ $t('basetarif') }}
                                    </b-col>
                                    <b-col sm="3">
                                        <label for="" style="width : 100%" class="text-center"> {{ $t('training') }} </label>
                                        <base-input disabled class="mb-2" v-model="filter.base1"></base-input>
                                    </b-col>
                                    <b-col sm="3">
                                        <label for="" style="width : 100%" class="text-center"> {{ $t('pedagogical') }} </label>
                                        <base-input disabled class="mb-2" v-model="filter.base2"></base-input>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                        
                        <b-row class="mt-3">
                            <b-col>
                                <b-row>
                                    <b-col sm="6" class="d-flex align-items-center justify-content-center text-center">
                                        {{ $t('load') }}
                                    </b-col>
                                    <b-col sm="3">
                                        <label for="" style="width : 100%" class="text-center"> {{ $t('training') }} </label>
                                        <base-input v-model="filter.load1" :disabled="!filter.teacher"  @keyup="ChangeLoad1" class="mb-2" ></base-input>
                                    </b-col>
                                    <b-col sm="3">
                                        <label for="" style="width : 100%" class="text-center"> {{ $t('pedagogical') }} </label>
                                        <base-input v-model="filter.load2" disabled class="mb-2" ></base-input>
                                    </b-col>
                                    <b-col sm="6">

                                    </b-col>
                                    <b-col sm="3">
                                        <label for="" style="width : 100%" class="text-center"> {{ $t('educationhourinhouse') }} </label>
                                        <base-input :disabled="!filter.teacher" v-model="filter.educationhourinhouse" @keyup="ChangeEduhourHouse" class="mb-2" ></base-input>
                                    </b-col>
                                    <b-col sm="3">
                                        <label for="" style="width : 100%" class="text-center"> {{ $t('total') }} </label>
                                        <base-input disabled v-model="filter.total" class="mb-2" ></base-input>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                    </b-card>
                    <b-card class="my-card-style mt-5">
                        <b-row >
                        <b-col sm="12" md="6" v-if="filter.bandlikturiid == 1" class="my-2">
                            <b-row>
                                <b-col>
                                    <b-form-checkbox @input="HideCalcPart" v-model="classroompremium.isVisible" size="lg"> 
                                        <h5> {{ $t('classroompremium') }} <b-icon id="classroompremiumMessage"  icon="question-circle-fill"></b-icon> </h5> 
                                    </b-form-checkbox>
                                    <b-popover target="classroompremiumMessage" triggers="hover" placement="top">
                                        <a target="_blank" href="https://lex.uz/docs/941876"> {{ $t('classroompremiumMessage') }} </a>
                                    </b-popover>
                                </b-col>
                            </b-row>
                            <b-row v-if="classroompremium.isVisible">
                                <b-col>
                                    <label for=""> <h5> {{ $t('countstudentofclass') }} </h5> </label>
                                    <!-- <base-input @keyup="ChangeClassRomm" v-model="classroompremium.countstudent" class="mb-2" ></base-input> -->
                                    <b-form-select @input="ChangeClassRomm" class="mb-2"  v-model="classroompremium.countstudent" :options="CountStudentList">
                                        <template #first>
                                            <b-form-select-option :value="null" disabled>-- {{$t('ChooseBelow')}} --</b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </b-col>
                            </b-row>
                           
                        </b-col>
                        <b-col sm="12" md="6" class="my-2">
                            <b-row >
                                <b-col>
                                    <b-form-checkbox @input="ChangeUnivercity" v-model="premiumTIU.isVisible" size="lg"> 
                                        <h5> {{ $t('premiumTIU') }} <b-icon id="premiumTIUMessage"   icon="question-circle-fill"></b-icon> </h5> 
                                    </b-form-checkbox>
                                    <b-popover target="premiumTIUMessage" triggers="hover" placement="top">
                                        <a target="_blank" href="https://lex.uz/docs/837202"> {{ $t('premiumTIUMessage') }} </a>
                                    </b-popover>
                                </b-col>
                            </b-row>
                            <b-row v-if="premiumTIU.isVisible">
                                <b-col>
                                    <!-- <label for=""> <h5> {{ $t('percentofpremium') }}  %</h5> </label> -->
                                    <base-input disabled  v-model="premiumTIU.percent" class="mb-2" ></base-input>
                                </b-col>
                            </b-row>
                            
                        </b-col>
                        <b-col sm="12" md="6" class="my-2" v-if="filter.bandlikturiid == 1">
                            <b-row>
                                <b-col>
                                    <b-form-checkbox @input="HideCalcPart" :disabled="excellentteacher.isVisible" v-model="qualificationpremium.isVisible" size="lg"> 
                                        <h5> {{ $t('qualificationpremium') }} <b-icon  id='qualificationpremiumMessage'  icon="question-circle-fill"></b-icon> </h5> 
                                        <b-popover target="qualificationpremiumMessage" triggers="hover" placement="top">
                                            <a target="_blank" href="https://lex.uz/docs/837202"> {{ $t('qualificationpremiumMessage') }} </a>
                                        </b-popover>
                                    </b-form-checkbox>
                                </b-col>
                            </b-row>
                            <b-row v-if="qualificationpremium.isVisible">
                                <b-col>
                                    <!-- <label for=""> <h5> {{ $t('percentofpremium') }} %</h5> </label> -->
                                    <base-input @keyup="ChangeQualificationPremium" v-model="qualificationpremium.percent" class="mb-2" ></base-input>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col sm="12" md="6" class="my-2">
                            <b-row>
                                <b-col>
                                    <b-form-checkbox @input="HideCalcPart" v-model="remoteregions.isVisible" size="lg"> 
                                        <h5> {{ $t('remoteregions') }} <b-icon  id="remoteregionsMessage"  icon="question-circle-fill"></b-icon> </h5> 
                                        <b-popover target="remoteregionsMessage" triggers="hover" placement="top">
                                            <a target="_blank" href="https://lex.uz/docs/4367859"> {{ $t('remoteregionsMessage') }} </a>
                                        </b-popover>
                                    </b-form-checkbox>
                                </b-col>
                            </b-row>
                            <b-row v-if="remoteregions.isVisible">
                                <b-col>
                                    <label for=""> <h5> {{ $t('expreinceinjob') }} </h5> </label>
                                    <!-- <base-input @keyup="ChangeRemoteRegions" v-model="remoteregions.month" class="mb-2" ></base-input> -->
                                    <b-form-select @input="ChangeRemoteRegions" class="mb-2"  v-model="remoteregions.month" :options="RemoteRegionsList">
                                        <template #first>
                                            <b-form-select-option :value="null" disabled>-- {{$t('ChooseBelow')}} --</b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col sm="12" md="6" class="my-2">
                            <b-row v-if="filter.subject == 8 || filter.subject == 46 || filter.subject == 7">
                                <b-col>
                                    <b-form-checkbox @input="HideCalcPart" v-model="computercabinetpremium.isVisible" size="lg"> 
                                        <h5> {{ $t('computercabinetpremium') }} <b-icon  id="computercabinetpremiumMessage" icon="question-circle-fill"></b-icon> </h5> 
                                        <b-popover target="computercabinetpremiumMessage" triggers="hover" placement="top">
                                            <a target="_blank" href="https://lex.uz/docs/941876"> {{ $t('computercabinetpremiumMessage') }} </a>
                                        </b-popover>
                                    </b-form-checkbox>
                                </b-col>
                            </b-row>
                            <b-row v-if="computercabinetpremium.isVisible">
                                <b-col>
                                    <label for=""> <h5>{{ $t('percentofpremium') }} %</h5> </label>
                                    <base-input disabled  v-model="computercabinetpremium.percent" class="mb-2" ></base-input>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col sm="12" md="6" class="my-2">
                           <b-row v-if="filter.subject == 16">
                                <b-col>
                                    <b-form-checkbox @input="ChangeWomanPremium"  v-model="womanpremium.isVisible" size="lg"> 
                                        <h5> {{ $t('womanpremium') }}  <b-icon id="womanpremiumMessage"  icon="question-circle-fill"></b-icon> </h5>
                                    </b-form-checkbox>
                                    <b-popover target="womanpremiumMessage" triggers="hover" placement="top">
                                        <a target="_blank" href="https://lex.uz/docs/1606175"> {{ $t('womanpremiumMessage') }} </a>
                                    </b-popover>
                                </b-col>
                            </b-row>
                            <b-row v-if="filter.subject == 16">
                                <b-col>
                                    <label for=""> <h5>{{ $t('percentofpremium') }} %</h5> </label>
                                    <base-input disabled  v-model="womanpremium.percent" class="mb-2" ></base-input>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col class="mt-3" sm="12" md="6" v-if="(filter.subject == 27 || filter.subject == 28 || filter.subject == 29 || filter.subject == 30  || filter.subject == 51 || filter.subject == 52 || filter.subject == 53 
                || filter.subject == 55 || filter.subject == 56 || filter.subject == 57 || filter.subject == 58 || filter.subject == 59 ||filter.subject == 60)">
                            <b-row>
                                <b-col>
                                    <b-form-checkbox @input="HideCalcPart" v-model="foreignlangteacher.isVisible" size="lg"> <h5> {{ $t('foreignlangteacher') }} <b-icon  v-b-popover.hover.top="`${$t('foreignlangteacherMessage')}`"  icon="question-circle-fill"></b-icon> </h5> </b-form-checkbox>
                                </b-col>
                            </b-row>
                            <b-row v-if="foreignlangteacher.isVisible">
                                <b-col>
                                    <b-form-group  v-slot="{ ariaDescribedby }">
                                        <b-form-radio @change="ChangeForeignLangTeacher" v-model="foreignlangteacher.isCity" :aria-describedby="ariaDescribedby" name="some-radios" value="no">  {{ $t('village') }}  (30%) </b-form-radio>
                                        <b-form-radio @change="ChangeForeignLangTeacher" v-model="foreignlangteacher.isCity" :aria-describedby="ariaDescribedby" name="some-radios" value="yes"> {{ $t('city') }} (15%)</b-form-radio>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col class="mt-3" sm="12" md="6" v-if="checkingbookspremium.isVisible">
                           <b-row>
                                <b-col>
                                    <b-form-checkbox disabled  v-model="checkingbookspremium.isVisible" size="lg"> 
                                        <h5>{{ $t('checkingbookspremium') }} <b-icon id="checkingbookspremiumMessage"  icon="question-circle-fill"></b-icon> </h5>  
                                        <b-popover target="checkingbookspremiumMessage" triggers="hover" placement="top">
                                            <a target="_blank" href="https://lex.uz/docs/941876"> {{ $t('checkingbookspremiumMessage') }} </a>
                                        </b-popover>
                                    </b-form-checkbox>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <label for=""> <h5> {{ $t('countstudent') }} </h5> </label>
                                    <!-- <base-input @keyup="ChangeCheckingBooks" v-model="checkingbookspremium.countstudent" class="mb-2" ></base-input> -->
                                    <b-form-select @input="ChangeCheckingBooks" class="mb-2"  v-model="checkingbookspremium.countstudent" :options="CountStudentListForChB">
                                        <template #first>
                                            <b-form-select-option :value="null" disabled>-- {{$t('ChooseBelow')}} --</b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col class="mt-3" sm="12" md="6" v-if="disctriccoef.isVisible">
                            <b-row>
                                <b-col>
                                    <b-form-checkbox disabled v-model="disctriccoef.isVisible" size="lg"> <h5> {{ $t('disctriccoef') }} <b-icon  v-b-popover.hover.top="`${$t('disctriccoefMessage')}`"  icon="question-circle-fill"></b-icon> </h5> </b-form-checkbox>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <label for=""> <h5>{{ $t('percentofpremium') }} %</h5> </label>
                                    <base-input  @keyup="ChangeDistrcCoef" v-model="disctriccoef.percent" class="mb-2" ></base-input>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col class="mt-3" sm="12" md="6" >
                            <b-row>
                                <b-col>
                                    <b-form-checkbox  v-model="olimpiadwinner.isVisible" size="lg"> 
                                        <h5> {{ $t('olimpiadwinner') }} <b-icon  id="olimpiadwinnerMessage"  icon="question-circle-fill"></b-icon> </h5>
                                        <b-popover target="olimpiadwinnerMessage" triggers="hover" placement="top">
                                            <a target="_blank" href="https://lex.uz/docs/4320713"> {{ $t('olimpiadwinnerMessage') }} </a>
                                        </b-popover>
                                    </b-form-checkbox>
                                </b-col>
                            </b-row>
                            <b-row v-if="olimpiadwinner.isVisible">
                                <b-col sm="12">
                                    <label for=""> <h6> {{ $t('participateself') }} </h6> </label>
                                    <b-form-select @input="ChangeOlimpiadWinner1" class="mb-2"  v-model="olimpiadwinner.id1" :options="OlimpiadList1">
                                        <template #first>
                                            <b-form-select-option :value="null" disabled>-- {{$t('ChooseBelow')}} --</b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </b-col>
                                <b-col sm="12">
                                    <label for=""> <h6> {{ $t('participatestudent') }} </h6> </label>
                                    <b-form-select @input="ChangeOlimpiadWinner2" class="mb-2"  v-model="olimpiadwinner.id2" :options="OlimpiadList2">
                                        <template #first>
                                            <b-form-select-option :value="null" disabled>-- {{$t('ChooseBelow')}} --</b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col class="mt-3" sm="12" md="6" >
                            <b-row>
                                <b-col>
                                    <b-form-checkbox  v-model="doctorofscience.isVisible" size="lg"> 
                                        <h5> {{ $t('doctorofscience') }} <b-icon id="doctorofscienceMessage" icon="question-circle-fill"></b-icon> </h5> 
                                        <b-popover target="doctorofscienceMessage" triggers="hover" placement="top">
                                            <a target="_blank" href="https://lex.uz/docs/4662181"> {{ $t('doctorofscienceMessage') }} </a>
                                        </b-popover>
                                    </b-form-checkbox>
                                </b-col>
                            </b-row>
                            <b-row v-if="doctorofscience.isVisible">
                                <b-col sm="12">
                                    <b-form-select @input="Changedoctorofscience" class="mb-2"  v-model="doctorofscience.id" :options="DoctorOfScienceList">
                                        <template #first>
                                            <b-form-select-option :value="null" disabled>-- {{$t('ChooseBelow')}} --</b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col class="mt-3" sm="12" md="6" >
                            <b-row>
                                <b-col>
                                    <b-form-checkbox  v-model="faxriyunvon.isVisible" size="lg"> 
                                        <h5> {{ $t('faxriyunvon') }} <b-icon  id="faxriyunvonMessage"  icon="question-circle-fill"></b-icon> </h5> 
                                    </b-form-checkbox>
                                    <b-popover target="faxriyunvonMessage" triggers="hover" placement="top">
                                        <a target="_blank" href="https://lex.uz/docs/1297848"> {{ $t('faxriyunvonMessage') }} </a>
                                    </b-popover>
                                </b-col>
                            </b-row>
                            <b-row v-if="faxriyunvon.isVisible">
                                <b-col sm="12">
                                    <b-form-select @input="ChangeFaxriyUnvon" class="mb-2"  v-model="faxriyunvon.id" :options="FaxriyUnvonList">
                                        <template #first>
                                            <b-form-select-option :value="null" disabled>-- {{$t('ChooseBelow')}} --</b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col class="mt-3" sm="12" md="6" >
                            <b-row>
                                <b-col>
                                    <b-form-checkbox  v-model="redschool.isVisible" size="lg"> <h5> {{ $t('redschool') }} <b-icon  v-b-popover.hover.top="`${$t('redschoolMessage')}`"  icon="question-circle-fill"></b-icon> </h5> </b-form-checkbox>
                                </b-col>
                            </b-row>
                            <b-row v-if="redschool.isVisible">
                                <b-col sm="12">
                                    <b-form-select @input="ChangeRedSchool" class="mb-2"  v-model="redschool.id" :options="RedSchoolList">
                                        <template #first>
                                            <b-form-select-option :value="null" disabled>-- {{$t('ChooseBelow')}} --</b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col class="mt-3" sm="12" md="6" v-if="filter.subject == 7 || filter.subject == 8 || filter.subject == 46 || filter.subject == 10">
                            <b-row>
                                <b-col>
                                    <b-form-checkbox @input="ChangeFanSertifikati" :disabled="specschool.isVisible" v-model="fansertifikat.isVisible" size="lg"> <h5> {{ $t('fansertifikat') }} <b-icon  v-b-popover.hover.top="`${$t('fansertifikatMessage')}`"  icon="question-circle-fill"></b-icon> </h5> </b-form-checkbox>
                                </b-col>
                            </b-row>
                            <b-row v-if="fansertifikat.isVisible">
                                <b-col sm="12">
                                    <!-- <label for=""> <h5>{{ $t('percentoffansertifikat') }} %</h5> </label> -->
                                    <base-input disabled  v-model="fansertifikat.percent" class="mb-2" ></base-input>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col class="mt-3" sm="12" md="6" v-if="filter.bandlikturiid == 1">
                            <b-row>
                                <b-col>
                                    <b-form-checkbox @input="ChangeExcellentTeacher" :disabled="qualificationpremium.isVisible" v-model="excellentteacher.isVisible" size="lg"> <h5> {{ $t('excellentteacher') }} <b-icon  v-b-popover.hover.top="`${$t('excellentteacherMessage')}`"  icon="question-circle-fill"></b-icon> </h5> </b-form-checkbox>
                                </b-col>
                            </b-row>
                            <b-row v-if="excellentteacher.isVisible">
                                <b-col sm="12">
                                    <!-- <label for=""> <h5>{{ $t('percentofexcellentteacher') }} %</h5> </label> -->
                                    <base-input disabled   v-model="excellentteacher.percent" class="mb-2" ></base-input>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col class="mt-3" sm="12" md="6" >
                            <b-row>
                                <b-col>
                                    <b-form-checkbox @input="ChangeInvalidPerson" :disabled="specschool.isVisible" v-model="invalidperson.isVisible" size="lg"> <h5> {{ $t('invalidperson') }} <b-icon  v-b-popover.hover.top="`${$t('invalidpersonMessage')}`"  icon="question-circle-fill"></b-icon> </h5> </b-form-checkbox>
                                </b-col>
                            </b-row>
                            <b-row v-if="invalidperson.isVisible">
                                <b-col sm="12">
                                    <!-- <label for=""> <h5>{{ $t('percentofinvalidperson') }} %</h5> </label> -->
                                    <base-input disabled   v-model="invalidperson.percent" class="mb-2" ></base-input>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col class="mt-3" sm="12" md="6" v-if="filter.region == 112 || filter.region == 114 || filter.region == 135 || filter.region == 72">
                            <b-row>
                                <b-col>
                                    <b-form-checkbox  v-model="otherregion.isVisible" size="lg"> <h5> {{ $t('otherregion') }} <b-icon  v-b-popover.hover.top="`${$t('otherregionMessage')}`"  icon="question-circle-fill"></b-icon> </h5> </b-form-checkbox>
                                </b-col>
                            </b-row>
                            <b-row v-if="otherregion.isVisible">
                                <b-col sm="12">
                                    <b-form-select @input="ChangeOtherRegion" class="mb-2"  v-model="otherregion.id" :options="OtherRegionList">
                                        <template #first>
                                            <b-form-select-option :value="null" disabled>-- {{$t('ChooseBelow')}} --</b-form-select-option>
                                        </template>
                                    </b-form-select>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col class="mt-3" sm="12" md="6" v-if="(filter.subject == 27 || filter.subject == 28 || filter.subject == 29 || filter.subject == 30  || filter.subject == 51 || filter.subject == 52 || filter.subject == 53 
                || filter.subject == 55 || filter.subject == 56 || filter.subject == 57 || filter.subject == 58 || filter.subject == 59 ||filter.subject == 60)">
                            <b-row>
                                <b-col>
                                    <b-form-checkbox @input="ChangeImproveLang" v-model="improvelang.isVisible" size="lg"> <h5> {{ $t('improvelang') }} <b-icon  v-b-popover.hover.top="`${$t('improvelangMessage')}`"  icon="question-circle-fill"></b-icon> </h5> </b-form-checkbox>
                                </b-col>
                            </b-row>
                            <b-row v-if="improvelang.isVisible">
                                <b-col sm="12">
                                    <!-- <label for=""> <h5>{{ $t('percentofimprovelang') }} %</h5> </label> -->
                                    <base-input disabled   v-model="improvelang.percent" class="mb-2" ></base-input>
                                </b-col>
                            </b-row>
                        </b-col>
                        <b-col class="mt-3" sm="12" md="6" >
                            <b-row>
                                <b-col>
                                    <b-form-checkbox @input="ChangeSpecSchool" v-model="specschool.isVisible" :disabled="fansertifikat.isVisible || invalidperson.isVisible" size="lg"> 
                                        <h5> {{ $t('specschool') }} <b-icon  id="specschoolMessage"  icon="question-circle-fill"></b-icon> </h5> 
                                        <b-popover target="specschoolMessage" triggers="hover" placement="top">
                                            <a target="_blank" href="https://lex.uz/docs/1382066"> {{ $t('specschoolMessage') }} </a>
                                        </b-popover>
                                    </b-form-checkbox>
                                </b-col>
                            </b-row>
                            <b-row v-if="specschool.isVisible">
                                <b-col sm="12">
                                    <!-- <label for=""> <h5>{{ $t('percentofexcellentteacher') }} %</h5> </label> -->
                                    <base-input disabled   v-model="specschool.percent" class="mb-2" ></base-input>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                    </b-card>
                    
                    <b-row class="mt-3">
                        <b-col class="text-center">
                            <base-button @click="CalcTotalsum" type="primary" size="lg"> {{ $t('calculate') }} </base-button>
                            <base-button @click="CheckFromUzAsbo" type="success" size="lg">  {{ $t('CheckFromUzAsbo') }} </base-button>
                        </b-col>
                    </b-row>
                    <b-collapse v-model="checkuzasbocollapse">
                        <b-row class="mt-3">
                            <b-col>
                                <label for=""> {{ $t('phonenumber') }} </label>
                            </b-col>
                             <b-col>
                                <label for=""> {{ $t('pinfl') }} </label>
                            </b-col>
                            <b-col>
                                <label for=""> {{ $t('ondate') }} </label>
                            </b-col>
                            <!-- <b-col>
                                <label for=""> {{ $t('enddate') }} </label>
                            </b-col> -->
                            <b-col>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-input size="sm" style="height:35px" v-model="filter.phonenumber" type="number"></b-form-input>
                            </b-col>
                             <b-col>
                                <b-form-input size="sm" style="height:35px" v-model="filter.pinfl" type="number"></b-form-input>
                            </b-col>
                            <b-col>
                                <date-picker
                                    v-model="filter.Ondate"
                                    style="width:100%"
                                    size="sm"
                                    lang="ru"
                                    :placeholder="$t('ondate')"
                                    value-type="format"
                                    format="DD.MM.YYYY"
                                    ></date-picker>
                            </b-col>
                            <!-- <b-col>
                                <date-picker
                                    v-model="filter.enddate"
                                    style="width:100%"
                                    size="sm"
                                    lang="ru"
                                    :placeholder="$t('enddate')"
                                    value-type="format"
                                    format="DD.MM.YYYY"
                                    ></date-picker>
                            </b-col> -->
                            <b-col class="d-flex align-items-baseline">
                                <b-button variant="primary" @click="Check" class="mt-0" block> <b-spinner v-if="checkuzasbo" small></b-spinner> {{ $t('check') }} </b-button>
                            </b-col>
                        </b-row>
                        <b-row >
                            <b-col>
                                <table class="content-table">
                                    <thead>
                                        <tr>
                                            <td> {{ $t('calculated') }} </td>
                                            <td> {{ $t('percent') }} </td>
                                            <td> {{ $t('sum') }} </td>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item,index) in SalaryList" :key="'salary' + index">
                                            <td> {{ item.SubCalculationKind }} </td>
                                            <td></td>
                                            <td> {{ $options.filters.currency(item.Summa, {symbol: '', fractionCount: 2}) }}  </td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <th> {{ $t('total') }} </th>
                                            <th></th>
                                            <th>{{ $options.filters.currency(totalsumASBO, {symbol: '', fractionCount: 2}) }}  </th>
                                        </tr>
                                    </tfoot>
                                </table>
                            </b-col>
                        </b-row>
                    </b-collapse>
                    <b-row class="mt-3" v-if="previewTable"> 
                        <b-col>
                            <table class="content-table">
                                <thead>
                                    <tr>
                                        <td> {{ $t('calculated') }} </td>
                                        <td> {{ $t('percent') }} </td>
                                        <td> {{ $t('sum') }} </td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td> {{ $t('hourlysalary') }} </td>
                                        <td> {{ hourlysalary.percent }} </td>
                                        <td> {{ $options.filters.currency(hourlysalary.sum, {symbol: '', fractionCount: 2}) }} </td>
                                    </tr>
                                    <tr v-if="qualificationpremium.isVisible">
                                        <td> {{ $t('qualificationpremium') }} </td>
                                        <td> {{ qualificationpremium.percent }} </td>
                                        <td> {{ $options.filters.currency(qualificationpremium.sum, {symbol: '', fractionCount: 2}) }} </td>
                                    </tr>
                                    <tr v-if="checkingbookspremium.isVisible">
                                        <td> {{ $t('checkingbookspremium') }} </td>
                                        <td> {{ checkingbookspremium.percent }} </td>
                                        <td> {{ $options.filters.currency(checkingbookspremium.sum, {symbol: '', fractionCount: 2}) }}</td>
                                    </tr>
                                    <tr v-if="classroompremium.isVisible">
                                        <td> {{ $t('classroompremium') }} </td>
                                        <td> {{ classroompremium.percent }} </td>
                                        <td>{{ $options.filters.currency(classroompremium.sum, {symbol: '', fractionCount: 2}) }} </td>
                                    </tr>
                                    <tr v-if="computercabinetpremium.isVisible">
                                        <td> {{ $t('computercabinetpremium') }} </td>
                                        <td> {{ computercabinetpremium.percent }} </td>
                                        <td> {{ $options.filters.currency(computercabinetpremium.sum, {symbol: '', fractionCount: 2}) }} </td>
                                    </tr>
                                    <tr v-if="womanpremium.isVisible">
                                        <td> {{ $t('womanpremium') }} </td>
                                        <td> {{ womanpremium.percent }} </td>
                                        <td> {{  $options.filters.currency(womanpremium.sum, {symbol: '', fractionCount: 2}) }} </td>
                                    </tr>
                                    <tr v-if="remoteregions.isVisible">
                                        <td> {{ $t('remoteregions') }} </td>
                                        <td> {{ remoteregions.percent }} </td>
                                        <td> {{ $options.filters.currency(remoteregions.sum, {symbol: '', fractionCount: 2}) }}  </td>
                                    </tr>
                                    <tr v-if="disctriccoef.isVisible">
                                        <td> {{ $t('disctriccoef') }} </td>
                                        <td> {{ disctriccoef.percent }} </td>
                                        <td> {{ $options.filters.currency(disctriccoef.sum, {symbol: '', fractionCount: 2}) }} </td>
                                    </tr>
                                    <tr v-if="foreignlangteacher.isVisible">
                                        <td> {{ $t('foreignlangteacher') }} </td>
                                        <td> {{ foreignlangteacher.percent }} </td>
                                        <td> {{ $options.filters.currency(foreignlangteacher.sum, {symbol: '', fractionCount: 2}) }} </td>
                                    </tr>
                                    <tr v-if="premiumTIU.isVisible">
                                        <td> {{ $t('premiumTIU') }} </td>
                                        <td> {{ premiumTIU.percent }} </td>
                                        <td> {{ $options.filters.currency(premiumTIU.sum, {symbol: '', fractionCount: 2}) }} </td>
                                    </tr>
                                    <tr v-if="olimpiadwinner.id1 !== null">
                                        <td> {{ $t('participateself') }} </td>
                                        <td> {{ olimpiadwinner.percent1 }} </td>
                                        <td> {{ $options.filters.currency(olimpiadwinner.sum1, {symbol: '', fractionCount: 2}) }} </td>
                                    </tr>
                                    <tr v-if="olimpiadwinner.id2 !== null">
                                        <td> {{ $t('participatestudent') }} </td>
                                        <td> {{ olimpiadwinner.percent2 }} </td>
                                        <td> {{ $options.filters.currency(olimpiadwinner.sum2, {symbol: '', fractionCount: 2}) }} </td>
                                    </tr>
                                    <tr v-if="doctorofscience.isVisible">
                                        <td> {{ $t('doctorofscience') }} </td>
                                        <td> {{ doctorofscience.percent }} </td>
                                        <td> {{ $options.filters.currency(doctorofscience.sum, {symbol: '', fractionCount: 2}) }} </td>
                                    </tr>
                                    <tr v-if="faxriyunvon.isVisible">
                                        <td> {{ $t('faxriyunvon') }} </td>
                                        <td> {{ faxriyunvon.percent }} </td>
                                        <td> {{ $options.filters.currency(faxriyunvon.sum, {symbol: '', fractionCount: 2}) }} </td>
                                    </tr>
                                    <tr v-if="redschool.isVisible">
                                        <td> {{ $t('redschool') }} </td>
                                        <td> {{ redschool.percent }} </td>
                                        <td> {{ $options.filters.currency(redschool.sum, {symbol: '', fractionCount: 2}) }} </td>
                                    </tr>
                                    <tr v-if="fansertifikat.isVisible">
                                        <td> {{ $t('fansertifikat') }} </td>
                                        <td> {{ fansertifikat.percent }} </td>
                                        <td> {{ $options.filters.currency(fansertifikat.sum, {symbol: '', fractionCount: 2}) }} </td>
                                    </tr>
                                    <tr v-if="excellentteacher.isVisible">
                                        <td> {{ $t('excellentteacher') }} </td>
                                        <td> {{ excellentteacher.percent }} </td>
                                        <td> {{ $options.filters.currency(excellentteacher.sum, {symbol: '', fractionCount: 2}) }} </td>
                                    </tr>
                                    <tr v-if="invalidperson.isVisible">
                                        <td> {{ $t('invalidperson') }} </td>
                                        <td> {{ invalidperson.percent }} </td>
                                        <td> {{ $options.filters.currency(invalidperson.sum, {symbol: '', fractionCount: 2}) }} </td>
                                    </tr>
                                    <tr v-if="otherregion.isVisible">
                                        <td> {{ $t('otherregion') }} </td>
                                        <td> {{ otherregion.percent }} </td>
                                        <td> {{ $options.filters.currency(otherregion.sum, {symbol: '', fractionCount: 2}) }} </td>
                                    </tr>
                                    <tr v-if="improvelang.isVisible">
                                        <td> {{ $t('improvelang') }} </td>
                                        <td> {{ improvelang.percent }} </td>
                                        <td> {{ $options.filters.currency(improvelang.sum, {symbol: '', fractionCount: 2}) }} </td>
                                    </tr>
                                    <tr v-if="specschool.isVisible">
                                        <td> {{ $t('specschool') }} </td>
                                        <td> {{ specschool.percent }} </td>
                                        <td> {{ $options.filters.currency(specschool.sum, {symbol: '', fractionCount: 2}) }} </td>
                                    </tr>
                                    <tr v-if="!!filter.educationhourinhouse">
                                        <td> {{ $t('educationhourinhouse') }} </td>
                                        <td> {{ filter.educationhourinhouse }} </td>
                                        <td> {{ $options.filters.currency(filter.educationhourinhouseprice, {symbol: '', fractionCount: 2}) }} </td>
                                    </tr>
                                    <tr v-if="!!filter.educationhourinhouse">
                                        <td> {{ $t('educationhourinloadhouse') }} </td>
                                        <td> 50% </td>
                                        <td> {{ $options.filters.currency(filter.educationhourinhouseloadprice, {symbol: '', fractionCount: 2}) }} </td>
                                    </tr>
                                </tbody>
                                <tfoot style="background-color : #7467F0;color:white">
                                    <tr>
                                        <td> {{ $t('totalsum') }} </td>
                                        <td>  </td>
                                        <td> {{ $options.filters.currency(totalsum, {symbol: '', fractionCount: 2}) }} </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </b-col>
                    </b-row>
                    <b-row class="mt-3" v-if="previewTable"> 
                        <b-col>
                            <table class="content-table">
                                <thead>
                                    <tr>
                                        <td> {{ $t('retention') }} </td>
                                        <td>  {{ $t('percent') }}  </td>
                                        <td> {{ $t('sum') }} </td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td> {{ $t('incometax') }} </td>
                                        <td> 12% </td>
                                        <td> {{ $options.filters.currency(incometax, {symbol: '', fractionCount: 2}) }}  </td>
                                    </tr>
                                    <tr>
                                        <td>{{ $t('profunion') }}</td>
                                        <td> 1% </td>
                                        <td> {{ $options.filters.currency(profunion, {symbol: '', fractionCount: 2}) }} </td>
                                    </tr>
                                </tbody>
                                <tfoot style="background-color : #7467F0;color:white">
                                    <tr>
                                        <td> {{ $t('totalsum') }} </td>
                                        <td>  </td>
                                        <td> {{ $options.filters.currency(incometax*1 + profunion*1, {symbol: '', fractionCount: 2}) }} </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </b-col>
                    </b-row>
                    <b-row class="mt-4">
                        <b-col class="text-center">
                            <h3> {{ $t('alltotalsum') }} : <b> {{ $options.filters.currency(alltotalsum, {symbol: '', fractionCount: 2}) }}  </b> </h3>
                        </b-col>
                    </b-row>
                </div>
            </div>
        </div>
    </section>

</template>
<script>
import TeacherList from '../../helper/teacher.json'
import BandlikTuriList from '../../helper/bandlikturi.json'
import SubjectLists from '../../helper/subject.json'
import QualificationCategoryList from '../../helper/qualificationcategory.json'
import OblastList from '../../helper/oblast.json'
import RegionList from '../../helper/region.json' 
import UnivercityList from '../../helper/univercity.json'
import SalaryCalculationService from '@/services/salarycalculation.service'
export default {
    data(){
        return{
            filter : {
                oblast : null,
                region : null,
                base1 : 0,
                base2 : 0,
                load1 : 0,
                load2 : 0,
                educationhourinhouse : 0,
                teacher : null,
                subject : null,
                qualificationcategory : null,
                univercity : null,
                bandlikturiid : null,
                educationhourinhouseprice : 0,
                educationhourinhouseloadprice : 0,
                total : 0,
                phonenumber:'',
                Ondate:'',
                startdate : '',
                enddate : '',
                pinfl : ''
            },
            mrot : 822000, 
            bxm : 270000,
            BandlikTuriList,
            checked : true,
            TeacherList,
            SubjectLists,
            QualificationCategoryList,
            OblastList,
            RegionList : [],
            UnivercityList,
            hourlysalary : {
                percent : 0,
                sum : 0,
                isVisible : false
            },
            classroompremium : {
                percent : 0,
                sum : 0,
                isVisible : false,
                countstudent : null
            },
            checkingbookspremium : {
                percent : 0,
                sum : 0,
                isVisible : false,
                countstudent : null
            },
            qualificationpremium : {
                percent : 0,
                sum : 0,
                isVisible : false
            },
            remoteregions : {
                percent : 0,
                sum : 0,
                month : null,
                isVisible : false
            },
            computercabinetpremium : {
                percent : 0,
                sum : 0,
                isVisible : false
            },
            womanpremium : {
                percent : 0,
                sum : 0,
                isVisible : false
            },
            foreignlangteacher:{
                isVisible : false,
                percent : 0,
                sum : 0,
                isCity : null
            },
            premiumTIU:{
                isVisible : false,
                percent : 0,
                sum : 0
            },
            disctriccoef  : {
                isVisible : false,
                percent : 0,
                sum  :0
            },
            olimpiadwinner : {
                isVisible : false,
                percent1 : 0,
                sum1 : 0,
                id1 : null,
                percent2 : 0,
                sum2 : 0,
                id2 : null,
            },
            doctorofscience : {
                isVisible : false,
                percent : 0,
                sum : 0,
                id : null
            },
            faxriyunvon : {
                isVisible : false,
                percent : 0,
                sum : 0,
                id : null
            },
            redschool : {
                isVisible : false,
                percent : 0,
                sum : 0,
                id : null
            },
            fansertifikat : {
                isVisible : false,
                percent : 0,
                sum : 0
            },
            excellentteacher : {
                isVisible : false,
                percent : 0,
                sum : 0
            },
            invalidperson : {
                isVisible : false,
                percent : 0,
                sum : 0
            },
            otherregion : {
                isVisible : false,
                percent : 0,
                sum : 0,
                id : null
            },
            improvelang : {
                isVisible : false,
                percent : 0,
                sum : 0,
            },
            specschool : {
                isVisible : false,
                percent : 0,
                sum : 0,
            },
            totalsum : 0,
            alltotalsum : 0,
            incometax : 0,
            profunion : 0,
            previewTable : false,
            checkuzasbo : false,
            checkuzasbocollapse : false,
            SalaryList : [],
            totalsumASBO : 0
        }
    },
    created(){
        // 
        this.SubjectLists = this.SubjectLists.sort((a, b) => a.name.localeCompare(b.name))
    },
    computed:{
         CountStudentList (){
             return  [
                {value : 1,text : `${this.$t('to15')}, 26.4%,  ${ this.$options.filters.currency(this.mrot*0.264, {symbol: '', fractionCount: 2}) } ${this.$t('som')}`},
                {value : 2,text : `${this.$t('from16to20')}, 31.6%, ${ this.$options.filters.currency(this.mrot*0.316, {symbol: '', fractionCount: 2})} ${this.$t('som')}`},
                {value : 3,text : `${this.$t('from21to25')}, 36.9%, ${ this.$options.filters.currency(this.mrot*0.369, {symbol: '', fractionCount: 2})} ${this.$t('som')}`},
                {value : 4,text : `${this.$t('from26to30')}, 42.1%, ${ this.$options.filters.currency(this.mrot*0.421, {symbol: '', fractionCount: 2})} ${this.$t('som')}`},
                {value : 5,text : `${this.$t('from31')}, 52.8%, ${ this.$options.filters.currency(this.mrot*0.528, {symbol: '', fractionCount: 2})} ${this.$t('som')}`},
            ]
         },
         CountStudentListForChB(){
             return  [
                {value : 1,text : `${this.$t('to15')}, 8.8%, ${ this.$options.filters.currency(this.mrot*0.088, {symbol: '', fractionCount: 2}) } ${this.$t('som')}`},
                {value : 2,text : `${this.$t('from16')}, 17.6%, ${ this.$options.filters.currency(this.mrot*0.176, {symbol: '', fractionCount: 2})} ${this.$t('som')}`}
            ]
         },
         RemoteRegionsList(){
             return [
                {value : 1,text : `${this.$t('to6mfrom3y')}, 10%,`},
                {value : 2,text : `${this.$t('from3yto5y')}, 20%,`},
                {value : 3,text : `${this.$t('from5yto10y')}, 30%,`},
                {value : 4,text : `${this.$t('from10yto15y')}, 40%,`},
                {value : 5,text : `${this.$t('from15y')}, 50%,`},
             ]
         },
         getLang(){
             return localStorage.getItem('lang')
         },
         OlimpiadList1 () {
             return [
                 { value : 1,text :  `${this.$t('international')}, 150%` },
                 { value : 2,text :  `${this.$t('republic')}, 100%` },
             ]
         },
         OlimpiadList2 () {
             return [
                { value : 3,text :  `${this.$t('place1')}, 200%`},
                { value : 4,text :  `${this.$t('place2')}, 175%`},
                { value : 5,text :  `${this.$t('place3')}, 150%`}
             ]
         },
         DoctorOfScienceList(){
             return [
                 { value : 1, text : `${this.$t('phD')}, 30%` },
                 { value : 2, text : `${this.$t('dS')}, 60%` }
             ]
         },
         FaxriyUnvonList (){
             return [
                 { value : 1, text : `${this.$t('XalqFaxriyUnvon')}, ${this.$t('Bxm300x')}` },
                 { value : 2, text : `${this.$t('ArtistFaxriyUnvon')}, ${this.$t('Bxm180x')}` },
                 { value : 3, text : `${this.$t('XizmatFaxriyUnvon')}, ${this.$t('Bxm160x')}` }
             ]
         },
         RedSchoolList(){
             return [
                 {value : 1,text : '50%'},
                 {value : 2,text : '100%'}
             ]
         },
         OtherRegionList(){
             return [
                 { value : 1, text : `${this.$t('from3y')}, 25%` },
                 { value : 2, text : `${this.$t('from3yto5y')}, 50%` },
                 { value : 3, text : `${this.$t('more5y')}, 75%` }
             ]
         }
    },
    methods:{
        Check(){
            this.checkuzasbo = true
            SalaryCalculationService.GetSalaryByPINFL(this.filter.phonenumber,this.filter.pinfl,this.filter.Ondate,).then(res => {
                this.checkuzasbo = false
                this.SalaryList = res.data
                var self = this
                this.totalsumASBO = 0
                self.SalaryList.forEach(function(item){
                    self.totalsumASBO += item.Summa
                })
            }).catch(error => {
                this.makeToast(error.response.data.error,this.$t('error'),'danger')
            })
        },
        CheckFromUzAsbo(){
            this.checkuzasbocollapse = !this.checkuzasbocollapse
            
        },
        calcTotalStudyTime(){
            // this.filter.total = this.filter.base1*1 + this.filter.load1*1 + this.filter.educationhourinhouse*1
            this.filter.total = this.filter.load1*1 + this.filter.load2*1 +  this.filter.educationhourinhouse*1
        },
        ChangeImproveLang(){
            this.HideCalcPart()
            if(this.improvelang.isVisible === true){
                this.improvelang.percent = 50
                this.improvelang.sum = this.hourlysalary.sum * this.improvelang.percent / 100
            }
            else{
                this.improvelang.percent = 0
                this.improvelang.sum = 0
            }
        },
        ChangeSpecSchool(){
            this.HideCalcPart()
            if(this.specschool.isVisible === true){
                this.specschool.percent = 20
                this.specschool.sum = this.hourlysalary.sum * this.specschool.percent / 100
            }
            else{
                this.specschool.percent = 0
                this.specschool.sum = 0
            }
        },
        ChangeOtherRegion(){
            this.HideCalcPart()
            if(this.otherregion.id == 1){
                this.otherregion.percent = 25
                this.otherregion.sum = this.hourlysalary.sum * this.otherregion.percent / 100
            }
            if(this.otherregion.id == 2){
                this.otherregion.percent = 50
                this.otherregion.sum = this.hourlysalary.sum * this.otherregion.percent / 100
            }
            if(this.otherregion.id == 3){
                this.otherregion.percent = 75
                this.otherregion.sum = this.hourlysalary.sum * this.otherregion.percent / 100
            }
        },
        ChangeInvalidPerson(){
            this.HideCalcPart()
            if(this.invalidperson.isVisible === true){
                this.invalidperson.percent = 100
                this.invalidperson.sum = this.hourlysalary.sum * this.invalidperson.percent / 100
            }
            else{
                this.invalidperson.percent = 0
                this.invalidperson.sum = 0
            }
        },
        ChangeExcellentTeacher(){
            this.HideCalcPart()
            if(this.excellentteacher.isVisible === true){
                this.excellentteacher.percent = 100
                this.excellentteacher.sum = this.hourlysalary.sum * this.excellentteacher.percent / 100
            }
            else{
                this.excellentteacher.percent = 0
                this.excellentteacher.sum = 0
            }
        },
        ChangeFanSertifikati(){
            this.HideCalcPart()
            if(this.fansertifikat.isVisible === true){
                this.fansertifikat.percent = 50
                this.fansertifikat.sum = this.hourlysalary.sum * this.fansertifikat.percent / 100
            }
            else{
                this.fansertifikat.percent = 0
                this.fansertifikat.sum = 0
            }
        },
        ChangeRedSchool(){
            this.HideCalcPart()
            if(this.redschool.id == 1){
                this.redschool.percent = 50
                this.redschool.sum = this.hourlysalary.sum * this.redschool.percent / 100
            }
            if(this.redschool.id == 2){
                this.redschool.percent = 100
                this.redschool.sum = this.hourlysalary.sum * this.redschool.percent / 100
            }
        },
        HideCalcPart(){
            this.alltotalsum = 0
            this.totalsum = 0
            this.previewTable = false
        },
        clear(){
            // if(this.previewTable === true){
               
                this.filter.base1 = 0
                this.filter.base2 = 0
                this.filter.load1 = 0
                this.filter.load2 = 0
                this.filter.educationhourinhouse = 0
                this.filter.total = 0
                this.hourlysalary = {
                    percent : 0,
                    sum : 0,
                    isVisible : false
                },
                this.classroompremium = {
                    percent : 0,
                    sum : 0,
                    isVisible : false,
                    countstudent : null
                },
                this.checkingbookspremium = {
                    percent : 0,
                    sum : 0,
                    isVisible : false,
                    countstudent : null
                },
                this.qualificationpremium = {
                    percent : 0,
                    sum : 0,
                    isVisible : false
                },
                this.remoteregions = {
                    percent : 0,
                    sum : 0,
                    month : null,
                    isVisible : false
                },
                this.computercabinetpremium = {
                    percent : 0,
                    sum : 0,
                    isVisible : false
                },
                this.womanpremium = {
                    percent : 0,
                    sum : 0,
                    isVisible : false
                },
                this.foreignlangteacher = {
                    isVisible : false,
                    percent : 0,
                    sum : 0,
                    isCity : null
                },
                this.premiumTIU = {
                    isVisible : false,
                    percent : 0,
                    sum : 0
                },
                this.disctriccoef = {
                    isVisible : false,
                    percent : 0,
                    sum  :0
                }
                this.olimpiadwinner = {
                    isVisible : false,
                    percent1 : 0,
                    sum1 : 0,
                    id1 : null,
                    percent2 : 0,
                    sum2 : 0,
                    id2 : null,
                }
                this.doctorofscience = {
                    isVisible : false,
                    percent : 0,
                    sum : 0,
                    id : null
                },
                this.faxriyunvon = {
                    isVisible : false,
                    percent : 0,
                    sum : 0,
                    id : null
                },
                this.redschool = {
                    isVisible : false,
                    percent : 0,
                    sum : 0,
                    id : null
                },
                this.fansertifikat = {
                    isVisible : false,
                    percent : 100,
                    sum : 0
                },
                this.excellentteacher = {
                    isVisible : false,
                    percent : 0,
                    sum : 0
                },
                this.invalidperson = {
                    isVisible : false,
                    percent : 0,
                    sum : 0
                },
                this.otherregion = {
                    isVisible : false,
                    percent : 0,
                    sum : 0,
                    id : null
                },
                this.improvelang = {
                    isVisible : false,
                    percent : 0,
                    sum : 0,
                },
                this.specschool = {
                    isVisible : false,
                    percent : 0,
                    sum : 0,
                },
                this.filter.educationhourinhouseprice = 0
                this.filter.educationhourinhouseloadprice = 0
                this.totalsum = 0
                this.alltotalsum = 0
                this.incometax = 0
                this.profunion = 0
                this.previewTable = false
                this.calcTotalStudyTime()
            // }
        },
        ChangeEduhourHouse(){
            if(this.filter.educationhourinhouse < 0){
                this.filter.educationhourinhouse = 0
            }
            if(this.filter.teacher == 1){
                if((this.filter.educationhourinhouse*1 + this.filter.load1*1) > 30){
                    this.filter.educationhourinhouse = 30 - this.filter.load1
                }
            }
            if(this.filter.teacher == 2){
                if(this.filter.educationhourinhouse + this.filter.load1 > 27){
                    this.filter.educationhourinhouse = 27 - this.filter.load1
                }
            }
            this.calcTotalStudyTime()
            
            if(this.filter.qualificationcategory == 1){
                this.filter.educationhourinhouseprice = (this.$store.state.qualificationcategory5 * this.filter.educationhourinhouse)/36 
                this.filter.educationhourinhouseloadprice = this.filter.educationhourinhouseprice / 2
            }
            if(this.filter.qualificationcategory == 2){
                this.filter.educationhourinhouseprice = (this.$store.state.qualificationcategory4 * this.filter.educationhourinhouse)/36 
                this.filter.educationhourinhouseloadprice = this.filter.educationhourinhouseprice / 2
            }
            if(this.filter.qualificationcategory == 3){
                this.filter.educationhourinhouseprice = (this.$store.state.qualificationcategory3 * this.filter.educationhourinhouse)/36 
                this.filter.educationhourinhouseloadprice = this.filter.educationhourinhouseprice / 2
            }
            if(this.filter.qualificationcategory == 4){
                this.filter.educationhourinhouseprice = (this.$store.state.qualificationcategory2 * this.filter.educationhourinhouse)/36 
                this.filter.educationhourinhouseloadprice = this.filter.educationhourinhouseprice / 2
            }
            if(this.filter.qualificationcategory == 5){
                this.filter.educationhourinhouseprice = (this.$store.state.qualificationcategory1 * this.filter.educationhourinhouse)/36 
                this.filter.educationhourinhouseloadprice = this.filter.educationhourinhouseprice / 2
            }
        },
        CalcTotalsum(){
            if(this.filter.oblast === null || this.filter.oblast === 0 || this.filter.oblast === undefined || this.filter.oblast === ""){
                this.makeToast(this.$t('NotSelectOblast'),this.$t('error'),'danger')
                return false
            }
            if(this.filter.region === null || this.filter.region === 0 || this.filter.region === undefined || this.filter.region === ""){
                this.makeToast(this.$t('NotSelectregion'),this.$t('error'),'danger')
                return false
            }
            if(this.filter.bandlikturiid === null || this.filter.bandlikturiid === 0 || this.filter.bandlikturiid === undefined || this.filter.bandlikturiid === ""){
                this.makeToast(this.$t('NotSelectbandlikturiid'),this.$t('error'),'danger')
                return false
            }
            if(this.filter.teacher === null || this.filter.teacher === 0 || this.filter.teacher === undefined || this.filter.teacher === ""){
                this.makeToast(this.$t('NotSelectteacher'),this.$t('error'),'danger')
                return false
            }
            if(this.filter.subject === null || this.filter.subject === 0 || this.filter.subject === undefined || this.filter.subject === ""){
                this.makeToast(this.$t('NotSelectsubject'),this.$t('error'),'danger')
                return false
            }
            if(this.filter.qualificationcategory === null || this.filter.qualificationcategory === 0 || this.filter.qualificationcategory === undefined || this.filter.qualificationcategory === ""){
                this.makeToast(this.$t('NotSelectqualificationcategory'),this.$t('error'),'danger')
                return false
            }
            if(this.filter.load1 === null || this.filter.load1 === 0 || this.filter.load1 === undefined || this.filter.load1 === ""){
                this.makeToast(this.$t('NotSelectload1'),this.$t('error'),'danger')
                return false
            }
            if(this.checkingbookspremium.isVisible === true){
                if(this.checkingbookspremium.sum === 0 || this.checkingbookspremium.sum === undefined || this.checkingbookspremium.sum === null || this.checkingbookspremium.sum === ""){
                    this.makeToast(this.$t('NotSelectcheckingbookspremium'),this.$t('error'),'danger')
                    return false
                }
            }
            
            this.previewTable = true
            this.totalsum = this.hourlysalary.sum *1 + 
            (this.classroompremium.isVisible ? this.classroompremium.sum * 1 : 0) + 
            this.checkingbookspremium.sum *1 + 
            this.qualificationpremium.sum *1 + 
            this.remoteregions.sum *1 + 
            (this.computercabinetpremium.isVisible ?  this.computercabinetpremium.sum * 1 : 0) + 
            this.womanpremium.sum *1 + 
            (this.foreignlangteacher.isVisible ?  this.foreignlangteacher.sum*1 : 0) + 
            (this.olimpiadwinner.id1 != null ? this.olimpiadwinner.sum1 * 1 : 0 ) + 
            (this.olimpiadwinner.id2 != null ? this.olimpiadwinner.sum2 * 1 : 0 ) + 
            (this.doctorofscience.isVisible ? this.doctorofscience.sum * 1 : 0 ) + 
            (this.faxriyunvon.isVisible ? this.faxriyunvon.sum * 1 : 0 ) + 
            (this.redschool.isVisible ? this.redschool.sum * 1 : 0 ) + 
            (this.fansertifikat.isVisible ? this.fansertifikat.sum * 1 : 0 ) + 
            (this.excellentteacher.isVisible ? this.excellentteacher.sum * 1 : 0 ) + 
            (this.invalidperson.isVisible ? this.invalidperson.sum * 1 : 0 ) + 
            (this.otherregion.isVisible ? this.otherregion.sum * 1 : 0 ) + 
            (this.improvelang.isVisible ? this.improvelang.sum * 1 : 0 ) + 
            (this.specschool.isVisible ? this.specschool.sum * 1 : 0 ) + 
            this.premiumTIU.sum *1 + 
            this.disctriccoef.sum *1 + 
            this.filter.educationhourinhouseloadprice *1 + 
            this.filter.educationhourinhouseprice*1

            this.incometax = this.totalsum * 0.12
            this.profunion = this.totalsum * 0.01
            this.alltotalsum = this.totalsum - this.incometax - this.profunion
        },
        makeToast(message, title, type) {
            this.$bvToast.toast(message, {
                title: title,
                autoHideDelay: 2000,
                variant: type,
                solid: true,
            });
        },
        ChangeFaxriyUnvon(){
            this.HideCalcPart()
            if(this.faxriyunvon.id == 1){
                this.faxriyunvon.percent = 300
                this.faxriyunvon.sum = this.faxriyunvon.percent * this.bxm / 100
            }
            if(this.faxriyunvon.id == 2){
                this.faxriyunvon.percent = 180
                this.faxriyunvon.sum = this.faxriyunvon.percent * this.bxm / 100
            }
            if(this.faxriyunvon.id == 3){
                this.faxriyunvon.percent = 160
                this.faxriyunvon.sum = this.faxriyunvon.percent * this.bxm / 100
            }
        },
        ChangeOlimpiadWinner1(){
            this.HideCalcPart()
            if(this.olimpiadwinner.id1 == 1 ){
                this.olimpiadwinner.percent1 = 150
                this.olimpiadwinner.sum1 = this.hourlysalary.sum * this.olimpiadwinner.percent1 / 100
            }
            if(this.olimpiadwinner.id1 == 2 ){
                this.olimpiadwinner.percent1 = 100
                this.olimpiadwinner.sum1 = this.hourlysalary.sum * this.olimpiadwinner.percent1 / 100
            }
        },
        ChangeOlimpiadWinner2(){
            this.HideCalcPart()
            if(this.olimpiadwinner.id2 == 3 ){
                this.olimpiadwinner.percent2 = 200
                this.olimpiadwinner.sum2 = this.hourlysalary.sum * this.olimpiadwinner.percent2 / 100
            }
            if(this.olimpiadwinner.id2 == 4 ){
                this.olimpiadwinner.percent2 = 175
                this.olimpiadwinner.sum2 = this.hourlysalary.sum * this.olimpiadwinner.percent2 / 100
            }
            if(this.olimpiadwinner.id2 == 5 ){
                this.olimpiadwinner.percent2 = 150
                this.olimpiadwinner.sum2 = this.hourlysalary.sum * this.olimpiadwinner.percent2 / 100
            }
        },
        Changedoctorofscience(){
            this.HideCalcPart()
            if(this.doctorofscience.id == 1){
                this.doctorofscience.percent = 30
                this.doctorofscience.sum = this.hourlysalary.sum * this.doctorofscience.percent / 100
            }
            if(this.doctorofscience.id == 2){
                this.doctorofscience.percent = 60
                this.doctorofscience.sum = this.hourlysalary.sum * this.doctorofscience.percent / 100
            }
        },
        ChangeOblast(){
            this.clear()
            this.filter.region = null
            this.filter.teacher = null
            this.filter.subject = null
            this.filter.qualificationcategory = null
            this.filter.univercity = null
            this.RegionList =  RegionList
            if(!!this.filter.oblast){
                this.RegionList = this.RegionList.filter(item => item.oblastid === this.filter.oblast)
            }
        },
        ChangeRegion(){
            this.clear()
            this.filter.teacher = null
            this.filter.subject = null
            this.filter.qualificationcategory = null
            this.filter.univercity = null
            this.RegionFunc()
        },
        ChangeDistrcCoef(){
            this.HideCalcPart()
            this.disctriccoef.sum = this.disctriccoef.percent * this.Funcmrot() / 100
        },
        RegionFunc(){
            if(!!this.filter.region){
               
                if(this.filter.region == 114){
                    this.disctriccoef.isVisible = true
                    this.disctriccoef.percent = 60
                    this.disctriccoef.sum = this.disctriccoef.percent * this.Funcmrot() / 100
                }
                if(this.filter.region == 112 || this.filter.region == 111 || this.filter.region == 61){
                    this.disctriccoef.percent = 50
                    this.disctriccoef.sum = this.disctriccoef.percent * this.Funcmrot() / 100
                     this.disctriccoef.isVisible = true
                }
                if(this.filter.region == 82 || this.filter.region == 81 || this.filter.region == 106 || this.filter.region == 107 || this.filter.region == 108 || this.filter.region == 110 || this.filter.region == 113){
                    this.disctriccoef.percent = 30
                    this.disctriccoef.sum = this.disctriccoef.percent * this.Funcmrot()/100
                     this.disctriccoef.isVisible = true
                }
                if(this.filter.region == 79 || this.filter.region == 80 || this.filter.region == 83 || this.filter.region == 87 || this.filter.region == 84 || this.filter.region == 78 
                || this.filter.region == 88 || this.filter.region == 81 || this.filter.region == 115 || this.filter.region == 109 || this.filter.region == 60 || this.filter.region == 120 || this.filter.region == 52 || this.filter.region == 58){
                    this.disctriccoef.percent = 20
                    this.disctriccoef.sum = this.disctriccoef.percent * this.Funcmrot() / 100
                     this.disctriccoef.isVisible = true
                }
                if(this.filter.region == 91 || this.filter.region == 86 ){
                    this.disctriccoef.percent = 15
                    this.disctriccoef.sum = this.disctriccoef.percent * this.Funcmrot() / 100
                     this.disctriccoef.isVisible = true
                }
                if(this.filter.region == 77 || this.filter.region == 85 || this.filter.region == 89 || this.filter.region == 90){
                    this.disctriccoef.percent = 10
                    this.disctriccoef.sum = this.disctriccoef.percent * this.Funcmrot() / 100
                     this.disctriccoef.isVisible = true
                }
            }
        },
        Funcmrot(){
            if(this.hourlysalary.sum > this.mrot * 1.41){
                return this.mrot * 1.41
            }
            else{
                return this.hourlysalary.sum
            }
        },
        ChangeTeacher(){
            this.filter.subject = null
            this.filter.qualificationcategory = null
            this.filter.load1 = 0
            this.filter.load2 = 0
            this.clear()
            if(this.previewTable === true){
                this.filter.subject = null
                this.filter.qualificationcategory = null
                this.filter.univercity = null
            }
            
            if(!!this.filter.teacher){
                if(this.filter.teacher === 1){
                    this.filter.base1 = 20
                    this.filter.base2 = 16
                }
                else{
                    this.filter.base1 = 18
                    this.filter.base2 = 18
                }
            }
            this.calcTotalStudyTime()
        },
        ChangeBandlikTuri(){
            this.filter.teacher = null
            this.filter.subject = null
            this.filter.qualificationcategory = null
            this.filter.load1 = 0
            this.filter.load2 = 0
            this.filter.base1 = 0
            this.filter.base2 = 0
            this.calcTotalStudyTime()
        },
        ChangeLoad1(){
            if(this.filter.load1 < 0){
                this.filter.load1 = 0
            }
            if(this.filter.teacher == 1){
                if((this.filter.educationhourinhouse*1 + this.filter.load1*1) > 30){
                    this.filter.load1 = 30 - this.filter.educationhourinhouse
                }
            }
            if(this.filter.teacher == 2){
                if(this.filter.educationhourinhouse + this.filter.load1 > 27){
                    this.filter.load1 = 27 - this.filter.educationhourinhouse
                }
            }
            
            if(!!this.filter.load1){
                if(this.filter.teacher === 1){
                    this.filter.load2 = (this.filter.load1 * 1 * 0.8).toFixed(1)
                }
                else{
                    this.filter.load2 = this.filter.load1
                }
                if(this.filter.bandlikturiid == 2){
                    this.filter.load2 = 0
                }
                this.ChangeQualificationCategory()
                this.RegionFunc()
                this.ChangeUnivercity()
            }
            else{
                this.filter.load2 = 0
            }
            this.calcTotalStudyTime()
        },
        ChangeQualificationCategory(){
            // this.clear()
            // if(this.previewTable === true){
            //     this.filter.univercity = null
            // }
            this.previewTable = false
            this.filter.educationhourinhouseprice = 0
            this.filter.educationhourinhouseloadprice = 0
            if(!!this.filter.qualificationcategory){
                if(this.filter.qualificationcategory == 1){
                    if(this.filter.bandlikturiid == 1){
                        this.hourlysalary.sum = this.$store.state.qualificationcategory5  * (this.filter.load1 * 1  + this.filter.load2 * 1) / (this.filter.base1 *1 + this.filter.base2*1)
                    }
                    else{
                        this.hourlysalary.sum = (this.$store.state.qualificationcategory5  * 1.2 * 4.3 * this.filter.load1) / 100 
                    }
                }
                if(this.filter.qualificationcategory == 2){
                    if(this.filter.bandlikturiid == 1){
                        this.hourlysalary.sum = this.$store.state.qualificationcategory4  * (this.filter.load1 * 1  + this.filter.load2 * 1) / (this.filter.base1 *1 + this.filter.base2*1)
                    }
                    else{
                        this.hourlysalary.sum = (this.$store.state.qualificationcategory4  * 1.2 * 4.3 * this.filter.load1)/100
                    }
                }
                if(this.filter.qualificationcategory == 3){
                    if(this.filter.bandlikturiid == 1){
                        this.hourlysalary.sum = this.$store.state.qualificationcategory3  * (this.filter.load1 * 1  + this.filter.load2 * 1) / (this.filter.base1 *1 + this.filter.base2*1)
                    }
                    else{
                        this.hourlysalary.sum = (this.$store.state.qualificationcategory3  * 1.2 * 4.3 * this.filter.load1)/100
                    }
                }
                if(this.filter.qualificationcategory == 4){
                    if(this.filter.bandlikturiid == 1){
                        this.hourlysalary.sum = this.$store.state.qualificationcategory2  * (this.filter.load1 * 1  + this.filter.load2 * 1) / (this.filter.base1 *1 + this.filter.base2*1)
                    }
                    else{
                        this.hourlysalary.sum = (this.$store.state.qualificationcategory2  * 1.2 * 4.3 * this.filter.load1)/100
                    }
                }
                if(this.filter.qualificationcategory == 5){
                    if(this.filter.bandlikturiid == 1){
                        this.hourlysalary.sum = this.$store.state.qualificationcategory1  * (this.filter.load1 * 1  + this.filter.load2 * 1) / (this.filter.base1 *1 + this.filter.base2*1)
                    }
                    else{
                        this.hourlysalary.sum = (this.$store.state.qualificationcategory1  * 1.2 * 4.3 * this.filter.load1)/100
                    }
                }
            }
        },
        ChangeClassRomm(){
            this.HideCalcPart()
            if(!!this.classroompremium.countstudent){
                if(this.classroompremium.countstudent === 1){
                    this.classroompremium.sum = this.mrot * 0.264
                    this.classroompremium.percent = 26.4
                }
                if(this.classroompremium.countstudent === 2){
                    this.classroompremium.sum = this.mrot * 0.316
                    this.classroompremium.percent = 31.6
                }
                if(this.classroompremium.countstudent === 3){
                    this.classroompremium.sum = this.mrot * 0.369
                    this.classroompremium.percent = 36.9
                }
                if(this.classroompremium.countstudent === 4){
                    this.classroompremium.sum = this.mrot * 0.421
                    this.classroompremium.percent = 42.1
                }
                if(this.classroompremium.countstudent === 5){
                    this.classroompremium.sum = this.mrot * 0.528
                    this.classroompremium.percent = 52.8
                }
            }
        },
        ChangeCheckingBooks(){
            this.HideCalcPart()
            if(!!this.checkingbookspremium.countstudent){
                if(this.checkingbookspremium.countstudent === 1){
                    this.checkingbookspremium.sum = this.mrot * 0.088 * this.filter.load1 / this.filter.base1
                    this.checkingbookspremium.percent = 8.8
                }
                else{
                    this.checkingbookspremium.sum = this.mrot * 0.176 * this.filter.load1 / this.filter.base1
                    this.checkingbookspremium.percent = 17.6
                }
            }
        },
        ChangeQualificationPremium(){
            this.HideCalcPart()
            if(this.qualificationpremium.percent < 0){
                this.qualificationpremium.percent = 0
            }
            if(this.qualificationpremium.percent > 40){
                this.qualificationpremium.percent = 40
            }
            if(!!this.qualificationpremium.percent){
                this.qualificationpremium.sum = this.hourlysalary.sum * this.qualificationpremium.percent * 1 / 100
            }
        },
        ChangeRemoteRegions(){
            this.HideCalcPart()
            if(!!this.remoteregions.month){
                if(this.remoteregions.month === 1){
                    this.remoteregions.percent = 10
                    this.remoteregions.sum = this.hourlysalary.sum * 10 / 100 
                }
                if(this.remoteregions.month === 2){
                    this.remoteregions.percent = 20
                    this.remoteregions.sum = this.hourlysalary.sum * 20 / 100 
                }
                if(this.remoteregions.month === 3){
                    this.remoteregions.percent = 30
                    this.remoteregions.sum = this.hourlysalary.sum * 30 / 100 
                }
                if(this.remoteregions.month === 4){
                    this.remoteregions.percent = 40
                    this.remoteregions.sum = this.hourlysalary.sum * 40 / 100 
                }
                if(this.remoteregions.month === 5){
                    this.remoteregions.percent = 50
                    this.remoteregions.sum = this.hourlysalary.sum * 50 / 100 
                }
            }
        },
        ChangeSubject(){
            // this.clear()
            this.previewTable = false
            this.filter.educationhourinhouse = 0
            this.filter.educationhourinhouseprice = 0
            this.filter.educationhourinhouseloadprice = 0
            if(!!this.filter.subject){
                if(this.filter.subject == 8 || this.filter.subject == 46 || this.filter.subject == 7){
                    this.computercabinetpremium.percent = 17.6
                    this.computercabinetpremium.sum = this.mrot * 17.6 / 100
                    // this.computercabinetpremium.isVisible = true
                }
                if(this.filter.subject == 27 || this.filter.subject == 28 || this.filter.subject == 29 || this.filter.subject == 30  || this.filter.subject == 51 || this.filter.subject == 52 || this.filter.subject == 53 
                || this.filter.subject == 55 || this.filter.subject == 56 || this.filter.subject == 57 || this.filter.subject == 58 || this.filter.subject == 59 ||this.filter.subject == 60){
                    this.foreignlangteacher.isVisible = true
                }
                else{
                    this.foreignlangteacher.isVisible = false
                }
                if(this.filter.subject == 19 || this.filter.subject == 21 || this.filter.subject == 7 ||  this.filter.subject == 56 || this.filter.subject == 57 || this.filter.subject == 58 || this.filter.subject == 59 
                || this.filter.subject == 60 || this.filter.subject == 44 || this.filter.subject == 25 || this.filter.subject == 26 || this.filter.subject == 45 ||this.filter.subject == 27 || 
                this.filter.subject == 28 || this.filter.subject == 29 || this.filter.subject == 30 || this.filter.subject == 51 || this.filter.subject == 52 || this.filter.subject == 53 || 
                this.filter.subject == 55){
                    this.checkingbookspremium.isVisible = true
                }
                else{
                    this.checkingbookspremium.isVisible = false
                }

                // else{
                //     this.computercabinetpremium.isVisible = false
                //     this.womanpremium.isVisible = false
                // }
                
            }
            // computercabinetpremium.percent
        },
        ChangeWomanPremium(){
            this.HideCalcPart()
            if(this.womanpremium.isVisible){
                this.womanpremium.percent = 15
                this.womanpremium.sum = this.hourlysalary.sum * 15 / 100
            }
        },
        ChangeForeignLangTeacher(){
            // alert("Sa")
            this.HideCalcPart()
            if(this.foreignlangteacher.isCity == 'no'){
                this.foreignlangteacher.sum = this.hourlysalary.sum * 30 / 100
                this.foreignlangteacher.percent = 30
            }
            if(this.foreignlangteacher.isCity == 'yes'){
                this.foreignlangteacher.sum = this.hourlysalary.sum * 15 / 100
                this.foreignlangteacher.percent = 15
            }
        },
        ChangeUnivercity(){
            this.HideCalcPart()
            if(this.premiumTIU.isVisible === true){
                this.premiumTIU.percent = 20
                this.premiumTIU.sum = this.hourlysalary.sum * 0.2
            }
            else{
                this.premiumTIU.percent = 0
                this.premiumTIU.sum = 0
            }
        }
    }
};
</script>
<style>
.my-card-style{
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}
</style>
